import { BlobProvider } from "@react-pdf/renderer";
import { ShipmentPdf } from "components/Pdfs/ShipmentPdf/ShipmentPdf";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import SaveAndSendShipmentEmail from "./SaveAndSendShipmentEmail";

export default function ShipmentTracking({
  shipment,
  products,
  refreshShipment,
}) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [formData, setFormData] = useState(null);

  const [shipmentMethods, setShipmentMethods] = useState(null);
  const [courierServices, setCourierServices] = useState(null);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  // Save tracking number
  const handleSaveTrackingNo = async () => {
    try {
      setLoading(true);
      const body = {
        id: shipment.id,
        ...formData,
      };
      const { data } = await API.patch("/sales/shipment", body, {
        headers: authHeader(),
      });
      if (data?.success) {
        await refreshShipment(shipment.shipmentId);
        // Optionally, you can show a success message or update the UI
        dispatch(
          setNotification({
            message: "Tracking number updated successfully",
            type: "success",
          }),
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getAllShipmentMethods = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/shipmentmethods", {
        headers: authHeader(),
      });
      setShipmentMethods(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getAllCouriers = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/courier-services", {
        headers: authHeader(),
      });
      setCourierServices(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setFormData(shipment);
  }, [shipment]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (!shipmentMethods) {
        getAllShipmentMethods();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [shipmentMethods]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (!courierServices) {
        getAllCouriers();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [courierServices]);

  return (
    <div className="w-100">
      {loading && <Spinner />}
      <div>
        <div
          className="border-bottom border-3 mb-2 pb-1 d-flex align-items-center justify-content-between"
          style={{}}
        >
          <h5 className="fw-bold mb-1">Tracking Number</h5>
        </div>
        {/* Input Form */}
        <>
          <div>
            {/* Courier Service */}
            <div className="mb-2 row">
              <div className="col-md-3 flex-center justify-content-start">
                <label
                  htmlFor="courierService"
                  className="form-label fw-semibold"
                >
                  Courier Service
                </label>
              </div>
              <div className="col-md-7">
                <select
                  id="courierService"
                  className="form-select"
                  value={formData?.courierServiceId || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      otherServiceName: null,
                      courierServiceId: e.target.value,
                    })
                  }
                >
                  <option value="">Select a courier service</option>
                  {courierServices &&
                    courierServices.map((service) => (
                      <option key={service.id} value={service.id}>
                        {service.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* Shipment Method */}
            <div className="mb-2 row">
              <div className="col-md-3 flex-center justify-content-start">
                <label
                  htmlFor="shipmentMethod"
                  className="form-label fw-semibold"
                >
                  Shipment Method
                </label>
              </div>
              <div className="col-md-7">
                <select
                  id="shipmentMethod"
                  className="form-select"
                  value={formData?.shippingMethodId || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      shippingMethodId: e.target.value,
                    })
                  }
                >
                  <option value="">Select a shipment method</option>
                  {shipmentMethods &&
                    shipmentMethods.map((method) => (
                      <option key={method.id} value={method.id}>
                        {method.shippingMethod}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* Tracking NO# */}
            <div className="mb-2 row">
              <div className="col-md-3 flex-center justify-content-start">
                <label htmlFor="trackingNo" className="form-label fw-semibold">
                  Tracking Number
                </label>
              </div>
              <div className="col-md-7">
                <input
                  type="text"
                  id="trackingNo"
                  className="form-control"
                  placeholder="Enter Tracking no #"
                  value={formData?.trackingNo || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, trackingNo: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        </>
      </div>
      {/* Save Button */}
      <div className="text-end">
        <div className="d-flex align-items-center gap-1 justify-content-end">
          {/* <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={async () => {
              await handleSaveTrackingNo();
            }}
            disabled={loading}
          >
            Save
          </button> */}
          {products && products?.length > 0 && shipment && (
            <SaveAndSendShipmentEmail
              trackingNo={formData?.trackingNo}
              shipment={shipment}
              products={products}
              handleSaveTrackingNo={handleSaveTrackingNo}
            />
          )}
        </div>
      </div>
    </div>
  );
}
